import type { MappedProject } from '../../interfaces/ui/addProjectModal';

// Maps fetched mapped projects API response for given APM number
export function toMappedProject(response: any): MappedProject[] {
  try {
    const projects = response?.data?.data?.[0]?.data?.[0]?.data ?? [];

    return projects.map((p: any) => ({
      projectId: p.projectid,
      projectName: p.projectname,
      projectOrg: p.projectorg,
      projectKey: p.projectkey,
      projectUrl: p.projecturl,
    })) as MappedProject[];
  } catch {
    return [];
  }
}
